<script>
import SearchTable from '@/components/SearchTableV3.vue';
import { keepNumber } from '@assets/js/regExUtil';

export default {
  name: 'subTable',
  components: { SearchTable },
  props: {
    showNumberOfPieces: {
      type: Boolean,
      default: true
    },
    stffList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    c_tableData() {
      return this.tableData.filter(item => item.destroy_flag !== 1);
    },
    c_tableProperties() {
      this.tableProperties.find(item => item.prop === 'rfid_sample_slicenum').invisible = !this.showNumberOfPieces;
      this.tableProperties.find(item => item.prop === 'experiment_stff_id').subItem.options = this.stffList.map(item => ({
        label: item.stff_name,
        value: item.stff_id
      }));
      return this.tableProperties;
    }
  },
  data() {
    return {
      tableProperties: [
        { prop: 'selection', type: 'selection', labelWidth: '48px' },
        {
          label: '试样个数',
          prop: 'rfid_sample_indnum',
          itemType: 'input',
          input: true,
          sortable: false,
          labelWidth: 120,
          subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.rfid_sample_indnum = keepNumber(val)) }
        },
        {
          label: '试样片数',
          prop: 'rfid_sample_slicenum',
          itemType: 'input',
          input: true,
          sortable: false,
          labelWidth: 120,
          subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.rfid_sample_slicenum = keepNumber(val)) }
        },
        {
          label: '试验制作人',
          prop: 'experiment_stff_id',
          itemType: 'input',
          input: true,
          sortable: false,
          labelWidth: 120,
          subItem: { type: 'select', options: [] }
        }
      ],
      tableData: [],
      currentRow: {},
      multiSelection: []
    };
  },
  methods: {
    addRow() {
      this.tableData.push({
        destroy_flag: 0,
        rfid_sample_indnum: null,
        rfid_sample_slicenum: null,
        experiment_stff_id: null
      });
    },
    delRow() {
      this.multiSelection.forEach(item => {
        item.destroy_flag = 1;
      });
    }
  }
};
</script>

<template>
  <div>
    <div class="vg_mb_8">
      <el-button class="buttonText" round size="mini" type="primary" @click="addRow">新增</el-button>
      <el-button class="buttonText" round size="mini" type="danger" @click="delRow">删除</el-button>
    </div>
    <search-table
      ref="searchTable"
      :columnMove="false"
      :columns="c_tableProperties"
      :data="c_tableData"
      :fixedHeightParam="500"
      :headerCellClassName="'headerCellClass'"
      :need-fixed-height="false"
      :need-pagination="false"
      :needSearch="false"
      :row-click="row => (currentRow = row)"
      :tableRowKey="'id'"
      @selection-change="val => (multiSelection = val)"
    />
  </div>
</template>

<style lang="scss" scoped>
::v-deep .headerCellClass {
  font-size: 28px;
  height: 78px;
  padding: 0;
}
.buttonText {
  font-size: 28px;
}
</style>
